/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */
import React from 'react'
import {
  Grid, Header, Item, Icon
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'

import ApplicationTrackerForm from './ApplicationTrackerForm'
import ApplicationDetails from './ApplicationDetails'
import './ApplicationTracker.css'

const ApplicationTrackerPV = (props) => {

  if (props.auth) {
    props.logout();
  }
  return (
    <div>
      <style>{`
        html {
          background: url(/enrollment/5.png) no-repeat center center fixed;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        }
        body {
          overflow-x: hidden;
          background: none;
        }
      `}
      </style>
      <div className='enrollment-header'>
        <Grid centered>
          <Grid.Column widescreen={10} computer={14} mobile={16}>
            <Grid columns={2}>
              <Grid.Column>
                <Item.Group className='orgid' unstackable>
                  <Item>
                    <Item.Content>
                      <Item.Header>
                        <h1 style={{ paddingTop:'3px', fontSize:'1.4em', color:'#000000' }}>
                          SALIS Enrollment
                        </h1>
                      </Item.Header>
                    </Item.Content>
                  </Item>
                </Item.Group>
              </Grid.Column>
              <Grid.Column textAlign='right' style={{paddingTop:'25px'}}>
                <NavLink key="enr" to="/enrollment">
                  <Icon name='home'/>
                  <span style={{veticalAlign: 'middle', fontSize:'1.2em', cursor: 'pointer'}}>
                    HOME
                  </span>
                </NavLink>
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
      <Grid centered>
        <Grid.Column width={10} textAlign='center' className='app-tracker-grid'>
          <Header className='app-tracker-title'>
            Enrollment Application Tracker
          </Header>
          <Header className='app-tracker-subtitle'>
            Input your Application Number
          </Header>
          <ApplicationTrackerForm
            appNumber={props.appNumber}
            handleChange={props.handleChange}
            getApplicant={props.getApplicant}
          />
          {
            props.applicant !== null?
            <ApplicationDetails
              applicant={props.applicant}
            />:
            <h3>Applicant not found. Make sure you have the correct application number.</h3>
          }
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default ApplicationTrackerPV
